import { useDarkMode } from "../../../context/ThemeContext";
import { getThemeClasses } from "../../../utils/ThemeClasses";

interface ReportMinMaxInputProps {
  lowValue: string;
  highValue: string;
  onChangeLow: (value: string) => void;
  onChangeHigh: (value: string) => void;
  lowPlaceholder?: string;
  highPlaceholder?: string;
  unit?: string;
}

export default function ReportMinMaxInput({
  lowValue,
  highValue,
  onChangeLow,
  onChangeHigh,
  lowPlaceholder,
  highPlaceholder,
  unit,
}: ReportMinMaxInputProps) {
  const { isDarkMode } = useDarkMode();
  const themeClasses = getThemeClasses(isDarkMode);

  return (
    <div className={`flex items-center h-10 rounded-lg border-2 ${themeClasses.inputBorder} ${themeClasses.inputBg}`}>
      <input
        value={lowValue ?? ""}
        onChange={(e) => onChangeLow(e.target.value)}
        placeholder={lowPlaceholder}
        className={`w-12 h-full px-1.5 bg-transparent text-center rounded-l-lg ${themeClasses.inputText} ${themeClasses.inputPlaceholder} focus:outline-none`}
      />
      <span className={`${themeClasses.textSecondary} text-xs shrink-0`}>–</span>
      <input
        value={highValue ?? ""}
        onChange={(e) => onChangeHigh(e.target.value)}
        placeholder={highPlaceholder}
        className={`w-12 h-full px-1.5 bg-transparent text-center ${themeClasses.inputText} ${themeClasses.inputPlaceholder} focus:outline-none`}
      />
      {unit && <span className={`pr-2 text-xs ${themeClasses.textSecondary} shrink-0`}>{unit}</span>}
    </div>
  );
}
